import { useLang } from "../i18n/LangContext";
import { useReveal } from "../hooks/useReveal";

function Step({ step, index, last }) {
    const { ref, className } = useReveal(0.1);
    return (
        <div
            ref={ref}
            data-testid={`method-step-${index + 1}`}
            style={{ transitionDelay: `${index * 100}ms` }}
            className={`${className} relative p-8 lg:p-10 border-r border-b border-ink bg-white hover:bg-paper-alt transition-colors`}
        >
            <div className="font-display font-bold text-6xl lg:text-7xl text-mint leading-none">
                {step.n}
            </div>
            <h3 className="mt-6 font-display font-bold uppercase text-lg md:text-xl tracking-tight text-ink leading-tight">
                {step.title}
            </h3>
            <p className="mt-3 text-sm md:text-base text-ink-soft leading-relaxed">
                {step.text}
            </p>
            {!last && (
                <span className="hidden lg:block absolute top-1/2 -right-3 w-6 h-px bg-ink" />
            )}
        </div>
    );
}

export default function Method() {
    const { t } = useLang();
    const { ref, className } = useReveal();
    return (
        <section
            id="method"
            data-testid="method-section"
            className="py-24 md:py-32 bg-white"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div ref={ref} className={`${className} max-w-3xl mb-20`}>
                    <div className="flex items-center gap-3 mb-6">
                        <span className="w-10 h-px bg-ink" />
                        <span className="font-display text-xs uppercase tracking-[0.3em] text-ink-muted">
                            {t.method.kicker}
                        </span>
                    </div>
                    <h2 className="font-display font-bold uppercase text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tight text-ink">
                        {t.method.title}
                    </h2>
                    <p className="mt-6 text-base md:text-lg text-ink-soft">
                        {t.method.subtitle}
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-0 border-l border-t border-ink">
                    {t.method.steps.map((step, i) => (
                        <Step
                            key={step.n}
                            step={step}
                            index={i}
                            last={i === t.method.steps.length - 1}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}
